import { AppText } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppMultipleSelectInput from "@toothfairy/shared-ui/AppMultipleSelectInput";
import AppPlaceholderView from "@toothfairy/shared-ui/AppPlaceholderView";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import { Platform, View } from "react-native";
import { useTranslation } from "react-i18next";
import { isLargeScreen } from "../Screens/MainViewContainer";
import ToothFairyModal from "./ToothFairyComponents/ToothFairyModal";

const DocumentSearchModal = ({
  isModalOpen,
  setIsModalOpen,
  searchText,
  setSearchText,
  handleDocumentSelection,
  promiseOptions,
  colourStyles,
}) => {
  const { currentTheme } = AppTheme.useTheme();
  const { t } = useTranslation();

  return (
    <ToothFairyModal
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      modalStyle={{
        height: "80%",
        width: Platform.OS === "web" && isLargeScreen() ? "70%" : "95%",
        maxWidth: 800,
        marginHorizontal: "auto",
        marginTop: "auto",
        marginBottom: "auto",
        borderRadius: 20,
      }}
      modalInnerContentStyle={{
        paddingHorizontal: 20,
        paddingVertical: 20,
      }}
      modalTitle={t("documents.search.title")}
    >
      <View
        style={{
          flex: 1,
          minHeight: 400,
        }}
      >
        <AppText
          wrapperStyle={{
            marginBottom: 15,
          }}
          color={currentTheme?.theme?.primary}
          style={{
            fontWeight: "bold",
            fontSize: currentTheme?.theme?.base_font_size,
          }}
        >
          {t("documents.search.description")}
        </AppText>

        <AppMultipleSelectInput
          accessibilityLabel="docs_search_modal"
          onSelectionChange={(v) => {
            handleDocumentSelection(v);
            setIsModalOpen(false);
          }}
          onInputChange={(v) => {
            setSearchText(v);
          }}
          autoFocus={true}
          inputValue={searchText}
          defaultInputValue={searchText}
          selectedItems={[]}
          labelOption={"title"}
          placeholder={t("documents.search.placeholder")}
          isAsync={true}
          promiseOptions={promiseOptions}
          uniqueKey="chunk_id"
          showDropDowns={true}
          readOnlyHeadings={true}
          styles={{
            ...colourStyles,
            control: (styles) => ({
              ...colourStyles.control(styles),
              minWidth: "100%",
              maxWidth: "100%",
              marginBottom: 0,
            }),
            menu: (styles) => ({
              ...colourStyles.menu(styles),
              zIndex: 1000,
            }),
          }}
          wrapperStyle={{
            flex: 1,
            zIndex: 1,
          }}
        />
        {(searchText?.trim() == "" || !searchText) && (
          <AppPlaceholderView
            accessibilityLabel="doc-placeholder"
            wrapperStyle={{
              width: 300,
              height: 200,
              marginVertical: "auto",
              marginHorizontal: "auto",
            }}
            size={30}
            icon={AppAssets.icons.orbit}
            mainCaption={t("documents.search.startTyping")}
            subCaption={t("documents.search.clickResult")}
          />
        )}
        <AppText
          wrapperStyle={{
            marginTop: 15,
            padding: 10,
            alignItems: "center",
            borderRadius: 8,
            position: "absolute",
            bottom: 0,
            zIndex: -1,
          }}
          color={currentTheme?.theme?.orange}
          style={{
            fontSize: currentTheme?.theme?.small_font_size || 12,
            textAlign: "center",
            marginLeft: 5,
            marginTop: 2,
          }}
          leftIcon={AppAssets?.icons?.info}
          iconSize={12}
        >
          {t("documents.search.firstSearchNote")}
        </AppText>
      </View>
    </ToothFairyModal>
  );
};

export default DocumentSearchModal;
